import { Link } from 'react-router-dom';
import { GameCard } from '../components/GameCard';
import { Building2, TrendingUp, Home } from 'lucide-react';

const immobilienGames = [
  {
    title: 'Wohnung kaufen oder mieten?',
    description: 'Die ewige Frage – beantworte ein paar Fragen zu deiner Situation und erhalte eine persönliche Einschätzung.',
    image: 'https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwbGl2aW5nJTIwcm9vbSUyMGludGVyaW9yJTIwZGVzaWdufGVufDB8fHx8MTc3NDI1Nzg3OXww&ixlib=rb-4.1.0&q=85',
    path: '/immobilien/wohnung-kaufen-oder-mieten',
    type: 'quiz',
    featured: true
  },
  {
    title: 'Was kostet dieses Haus?',
    description: 'Schätze den Wert verschiedener Immobilien in Südtirol und teste dein Marktgespür.',
    image: 'https://images.unsplash.com/photo-1734169065204-127b2b724c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBhbHBpbmUlMjBob3VzZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzQyNTc4NzZ8MA&ixlib=rb-4.1.0&q=85',
    path: '/tippspiele/was-kostet-dieses-haus',
    type: 'estimation'
  }
];

export default function Immobilien() {
  return (
    <div className="section-spacing" data-testid="immobilien-page">
      <div className="container-wide">
        {/* Header */}
        <div className="max-w-2xl mb-12">
          <nav className="text-sm text-[#64748B] mb-4" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#0284C7]">Start</Link>
            <span className="mx-2">/</span>
            <span className="text-[#0F172A]">Immobilien</span>
          </nav>
          
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-4 font-[var(--font-heading)]">
            Immobilien
          </h1>
          <p className="text-lg text-[#475569]">
            Entscheidungshilfen rund um Immobilienkauf, Miete und Investment. 
            Spielerisch zur besseren Einschätzung.
          </p>
        </div>

        {/* Quick Info Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {[
            {
              icon: Building2,
              title: 'Kaufen oder Mieten?',
              text: 'Die wichtigste Grundsatzentscheidung für deine Wohnsituation.'
            },
            {
              icon: TrendingUp,
              title: 'Preise einschätzen',
              text: 'Lerne, Immobilienwerte realistisch zu bewerten.'
            },
            {
              icon: Home,
              title: 'Richtig investieren',
              text: 'Verstehe, worauf es bei Immobilien als Anlage ankommt.'
            }
          ].map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="bg-white rounded-xl p-6 border border-[#E2E8F0]">
                <div className="w-10 h-10 rounded-lg bg-[#0284C7]/10 flex items-center justify-center mb-4">
                  <Icon className="text-[#0284C7]" size={20} />
                </div>
                <h3 className="font-semibold text-[#0F172A] mb-2">{item.title}</h3>
                <p className="text-sm text-[#475569]">{item.text}</p>
              </div>
            );
          })}
        </div>

        {/* Games Grid */}
        <h2 className="text-2xl font-bold text-[#0F172A] mb-6 font-[var(--font-heading)]">
          Interaktive Entscheidungshilfen
        </h2>
        <div className="bento-grid mb-12">
          {immobilienGames.map((game, index) => (
            <GameCard key={index} {...game} />
          ))}
        </div>

        {/* Info Content */}
        <div className="bg-[#F8FAFC] rounded-xl p-8 border border-[#E2E8F0]">
          <h2 className="text-xl font-semibold text-[#0F172A] mb-4 font-[var(--font-heading)]">
            Der Immobilienmarkt in Südtirol
          </h2>
          <div className="prose prose-slate max-w-none">
            <p className="text-[#475569] mb-4">
              Südtirol gehört zu den teuersten Immobilienmärkten Italiens. Die Kombination 
              aus begrenztem Bauland, hoher Lebensqualität und der Attraktivität als 
              Zweitwohnsitz-Region sorgt für überdurchschnittliche Preise.
            </p>
            <p className="text-[#475569] mb-4">
              Umso wichtiger ist eine fundierte Entscheidung: Lohnt sich der Kauf? 
              Welche Region passt zu meinem Budget? Unsere interaktiven Tools helfen 
              dir, die richtigen Fragen zu stellen.
            </p>
            <p className="text-[#475569]">
              Du suchst professionelle Unterstützung bei der Immobiliensuche? 
              Erfahrene Makler wie{' '}
              <a 
                href="https://amadeus.immo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#0284C7] hover:underline"
              >
                amadeus.immo
              </a>{' '}
              kennen den lokalen Markt und können dich kompetent beraten.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
